import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

type Props = {
  to: string;
  children: ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const DynamicLink = ({ to, children, ...rest }: Props) =>
  to.startsWith("http") ? (
    <a href={to} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
